export function sendEmail(to, subject, body) {
    // Simulate sending email
    console.log(`Email sent to ${to}: ${subject}\n${body}`);
}